import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo_abha_care.jpg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="bg-white shadow-md p-0 sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-[#96653a] p-2 h-12 text-white">
        <nav className="flex justify-end px-4 sm:px-10 lg:px-32 text-sm sm:text-base">
          <ul className="flex flex-wrap gap-4">
            <li className="">1300 157 211</li>
            <li className="">
              <Link to="/contact" className="hover:underline">
                info@abhacare.com.au
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Main Header */}
      <div className="container mx-auto flex justify-between items-center px-4 py-3">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="Logo" className="h-28 w-auto" />
        </Link>

        {/* Hamburger Button */}
        <button
          className="md:hidden text-gray-800 focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isMenuOpen ? (
              // Close Icon
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              // Hamburger Icon
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Desktop Menu */}
        <nav className="hidden md:flex gap-12 items-center text-gray-700 text-lg font-semibold font-inter">
          {["/", "/about", "/services", "/resources", "/contact"].map((path, i) => (
            <NavLink
              key={path}
              to={path} 
              className={({ isActive }) =>
                path === "/contact"
                  ? isActive
                    ? "bg-green-900 text-white px-4 py-2 rounded-lg"
                    : "bg-green-900 text-white px-4 py-2 rounded-lg hover:bg-green-600"
                  : isActive
                  ? "border-b-4 border-green-900 pb-1"
                  : "hover:border-b-2 hover:border-gray-400 pb-1"
              }
            >
              {["HOME", "ABOUT US", "SERVICES", "RESOURCES", "CONTACT US"][i]}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4">
          <nav className="flex flex-col gap-4 text-gray-800 text-base">
            <NavLink to="/" onClick={toggleMenu}>HOME</NavLink>
            <NavLink to="/about" onClick={toggleMenu}>ABOUT US</NavLink>
            <NavLink to="/services" onClick={toggleMenu}>SERVICES</NavLink>
            <NavLink to="/resources" onClick={toggleMenu}>RESOURCES</NavLink>
            <NavLink
              to="/contact"
              className="bg-green-900 text-white px-4 py-2 rounded-lg w-fit"
              onClick={toggleMenu}
            >
              CONTACT US
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
